import { useForm as createUseForm } from "@ant-design-vue/use";
import lodash from "lodash";
import { toRaw } from "vue";
import { createColumnDate, createColumnInput, createColumnInputNumber, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { initUseForm } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { createManageExportCsv, createPage } from "../../../../utils/page";
import { validateError } from "../../../../utils/validate";

export const { isLoading, setIsLoading } = createLoading();

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createColumns = ({ props }) => {
    const { visibleHealthCert } = props;
    const columns = [];
    if (visibleHealthCert) {
        columns.push(
            createColumnDate({
                title: () => i18n.global.t("model.certificateRequest.certificateDate"),
                dataIndex: "refCertificateRequest.certificateDate",
                align: "center"
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.certificateRequest.certificateNo"),
                dataIndex: "refCertificateRequest.certificateNo",
                width: 200,
                align: "center"
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.product.code"),
                dataIndex: "refCompanyProduct.refProduct.code",
                customRender: ({ record }) => (
                    <div>{record.refCompanyProduct?.refProduct?.code || record.refSamplingProduct?.refCompanyProduct?.refProduct?.code}</div>
                ),
                width: 200,
                align: "center"
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.product.nameTh"),
                dataIndex: "refCompanyProduct.refProduct.nameTh",
                customRender: ({ record }) => (
                    <div>{record.refCompanyProduct?.refProduct?.nameTh || record.refSamplingProduct?.refCompanyProduct?.refProduct?.nameTh}</div>
                ),
                width: 200
            })
        );
        columns.push(
            createColumnInput({
                title: () => i18n.global.t("model.product.nameEn"),
                dataIndex: "refCompanyProduct.refProduct.nameEn",
                customRender: ({ record }) => (
                    <div>{record.refCompanyProduct?.refProduct?.nameEn || record.refSamplingProduct?.refCompanyProduct?.refProduct?.nameEn}</div>
                ),
                width: 200
            })
        );
        columns.push(
            createColumnInputNumber({
                title: () => i18n.global.t("model.samplingProduct.exportAmount"),
                dataIndex: "exportAmount",
                width: 200,
                allowPrecision: true,
                inputProp: () => ({ allowPrecision: true })
            })
        );
        columns.push(
            createColumnSelect({
                title: () => i18n.global.t("model.certificateRequest.refExportCountry"),
                dataIndex: "refCertificateRequest.refExportCountry.nameEn",
                align: "center",
                search: { visible: () => false }
            })
        );
    }
    return columns;
};

export const initData = ({ props, data }) => {
    const { menuContext, viewOnly, itemsKey, visibleCompanyDocReject, visibleHealthCert } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [createManageExportCsv({ menuContext })];
    data.manageExtras = [];
    data.rowActions = [];

    if (!viewOnly) {
        if (visibleCompanyDocReject) {
            /*
            data.manageExtras.push({
                render: () => ({
                    ...createButtonCreate({
                        onClick: () => openModalListCompany({
                            onIframeMounted: ({ refs, options }) => onIFrameClickSelectAll({
                                refs, options, items, itemKey: 'refCompany.id', rowKey: 'id', setKey: 'refCompany'
                            }),
                        }),
                        options: { text: i18n.global.t('model.companyCountry.refCompany') }
                    }),
                }),
                visible: () => has({ menuContext, key: 'canCreate' }),
            })
            */
        }
        if (visibleHealthCert) {
            //
        }
    }
};

export const createField = () => {
    return [];
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page, routerPrefix }))
        .then(() => loadDefaultForm({ props, data }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] }, routerPrefix }))
        .finally(() => setIsLoading(false));
};

export const loadDefaultForm = () => {
    const promises = [];
    return Promise.all(promises);
};

export const initForm = ({ props, data, refs }) => {
    data.form = props.form ? props.form : {};
    data.rules = {};
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
